/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPSwitch from 'framework/components/DPSwitch'
import ReactPaginate from 'react-paginate'
import DPTextBox from 'framework/components/DPTextBox'
import DPTextBoxforgrid from 'framework/components/DPTextBoxforgrid'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';


const MealMasterContent = ({
    show,
    AlertMsg,
    AlertColor,
    salesAssistantList,
    setSalesAssistantList,
    mealList,
    setMeals,
    testingList,
    setTestingList,
    triggerChange,
    setSelectedDateOnchange,
    selectedDate,
    setAlertMsg,
    setShow,
    setAlertColor
}) => {

    const [page, setPage] = useState(1)
    // const [pageSize, setPageSize] = useState(20)

    const [expandedGroups, setExpandedGroups] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchByGroup, setSearchByGroup] = useState(true); // Default search by group
    const [pageSize, setPageSize] = useState(25); // Change this to adjust page size
    const [groupPages, setGroupPages] = useState({});

    useEffect(() => {
        setGroupPages({});
        setExpandedGroups([]);
    }, [triggerChange])

    // const toggleGroup = (group) => {
    //     if (expandedGroups.includes(group)) {
    //       setExpandedGroups(expandedGroups.filter((g) => g !== group));
    //     } else {
    //       // Check if the number of expanded groups is less than 10
    //       if (expandedGroups.length < 1) {
    //         setExpandedGroups([...expandedGroups, group]);
    //       } else {
    //         // If 10 groups are already expanded, remove the first expanded group and add the new one
    //         const newExpandedGroups = [...expandedGroups.slice(1), group];
    //         setExpandedGroups(newExpandedGroups);
    //       }
    //     }
    //   };
      
    const toggleGroup = (group) => {
       
        if (expandedGroups.includes(group)) {
            
            setExpandedGroups(expandedGroups.filter((g) => g !== group));
        } else {
            
            setExpandedGroups([...expandedGroups, group]);
        }
    };
    

    const isGroupExpanded = (group) => expandedGroups.includes(group);

    const handleSearchInputChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleHeaderClick = (type) => {
        setSearchByGroup(type === 'group');
    };

    const filteredTestingList = testingList.filter((item) => {
        if (searchByGroup) {
            return item.group.toLowerCase().includes(searchQuery.toLowerCase());
        }
    });



    const indexOfLastPost = page * pageSize
    const indexOfFirstPost = indexOfLastPost - pageSize

    const handleGroupPageChange = (group, page) => {
        setGroupPages({ ...groupPages, [group]: page });
    };




    const EnableDisableAllMealsGroup = (selectedMeal) => {

        if(selectedDate === ''){
            setAlertMsg("Please select a date")
            setShow(true)
            setAlertColor("danger")
            setTimeout(() => {
                setShow(false)
            }, 5000);
            return
        }

        const updatedList = testingList.map(group => {
            const allEnabled = group.data.every(salesAssistant =>
                salesAssistant.mealList.every(meal => meal.id !== selectedMeal.mealID || meal.eligible)
            );
    
            const newEligibleState = !allEnabled;
    
            return {
                ...group,
                data: group.data.map(salesAssistant => ({
                    ...salesAssistant,
                    mealList: salesAssistant.mealList.map(meal => {
                        if (meal.id === selectedMeal.mealID) {
                            return {
                                ...meal,
                                eligible: newEligibleState
                            };
                        }
                        return meal;
                    })
                }))
            };
        });

        setTestingList(updatedList)

    }


    const EnableDisableSlectedMealGroup = (group, salesAssistantCode, mealId) => {

        if(selectedDate === ''){
            setAlertMsg("Please select a date")
            setShow(true)
            setAlertColor("danger")
            setTimeout(() => {
                setShow(false)
            }, 5000);
            return
        }

        // Find the group in the testingList
        const groupData = testingList.find(item => item.group === group);

        // Find the sales assistant in the group
        const salesAssistant = groupData.data.find(salesAsst => salesAsst.code === salesAssistantCode);

        // Find the meal in the sales assistant's meal list
        const meal = salesAssistant.mealList.find(m => m.id === mealId);

        // Toggle the eligibility status of the meal
        meal.eligible = !meal.eligible;

        // Find the index of the sales assistant in the group
        const salesAssistantIndex = groupData.data.findIndex(salesAsst => salesAsst.code === salesAssistantCode);

        // Update the sales assistant's meal list in the testingList
        const updatedTestingList = testingList.map(item => {
            if (item.group === group) {
                return {
                    ...item,
                    data: item.data.map((assistant, index) => index === salesAssistantIndex ? salesAssistant : assistant)
                };
            } else {
                return item;
            }
        });

        // Set the updated testingList
        setTestingList(updatedTestingList);
    };


    return (
        <React.Fragment>
            <CardText className="mb-0">
                <Row>
                    {show ? (
                        <Alert color={AlertColor} role="alert">
                            {AlertMsg}
                            <br />
                        </Alert>
                    ) : null}
                </Row>
                <Row>
                    <Col md={6}>
                        <DPTextBox
                            textType={"date"}
                            labelText={"Select Date"}
                            value={selectedDate}
                            onChange={setSelectedDateOnchange}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={2} className='mb-2'>
                        <DPTextBoxforgrid
                            textType={"text"}
                            // placeholder={"Search by Group"}
                            placeholder={"Search by Department"}
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                        /></Col>


                    <table className="table table-striped table-sm border">
                        <thead>
                            <tr>
                                {/* <th style={{ width: '100px' }} onClick={() => handleHeaderClick('group')}>Group</th> */}
                                <th style={{ width: '100px' }} onClick={() => handleHeaderClick('group')}>Department</th>
                                <th style={{ width: '200px' }}>Sales Assistant</th>
                                {mealList.map((meal) => (
                                    <th key={meal.id} onClick={() => { EnableDisableAllMealsGroup(meal) }} style={{ textAlign: 'center', cursor: 'pointer' }}>{meal.mealName}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredTestingList.map((item1) => (
                                <React.Fragment key={item1.group}>
                                    <tr onClick={() => toggleGroup(item1.group)} style={{ cursor: 'pointer' }}>
                                        <td>{item1.group}</td>
                                        <td>
                                            {/* Render icon based on whether the group is expanded or collapsed */}
                                            {isGroupExpanded(item1.group) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </td>
                                        {mealList.map(() => <th key={Math.random()}></th>)}
                                    </tr>
                                    {expandedGroups.includes(item1.group) && (
                                        <React.Fragment>
                                            {item1.data
                                                .slice(((groupPages[item1.group] || 1) - 1) * pageSize, (groupPages[item1.group] || 1) * pageSize)
                                                .map((salesAssistant) => (
                                                    <tr key={salesAssistant.id}>
                                                        <td></td> {/* Empty cell for group column */}
                                                        <td>{salesAssistant.name}</td>
                                                        {salesAssistant.mealList.map((meal) => (
                                                            <td key={meal.id} style={{ textAlign: 'center' }}>
                                                                <DPSwitch
                                                                    checked={meal.eligible}
                                                                    onChange={() => { EnableDisableSlectedMealGroup(item1.group, salesAssistant.code, meal.id) }}
                                                                />
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))
                                            }

                                            {/* Pagination controls for expanded group */}
                                            <tr>
                                                <td colSpan={mealList.length + 2} style={{ textAlign: 'right' }}>
                                                    <div>
                                                        {/* Render "Previous" button if not on the first page */}
                                                        {groupPages[item1.group] && groupPages[item1.group] > 1 && (
                                                            <button
                                                                onClick={() => handleGroupPageChange(item1.group, groupPages[item1.group] - 1)}
                                                                style={buttonStyle}
                                                            >
                                                                Previous
                                                            </button>
                                                        )}
                                                        {/* Render pagination buttons for a limited range of pages */}
                                                        {Array.from({ length: Math.ceil(item1.data.length / pageSize) }, (_, i) => i + 1)
                                                            .slice(Math.max(0, (groupPages[item1.group] || 1) - 3), Math.min(Math.ceil(item1.data.length / pageSize), (groupPages[item1.group] || 1) + 4))
                                                            .map((page) => (
                                                                <button
                                                                    key={page}
                                                                    onClick={() => handleGroupPageChange(item1.group, page)}
                                                                    style={buttonStyle}
                                                                >
                                                                    {page}
                                                                </button>
                                                            ))}
                                                        {/* Render "Next" button if not on the last page */}
                                                        {groupPages[item1.group] && groupPages[item1.group] < Math.ceil(item1.data.length / pageSize) && (
                                                            <button
                                                                onClick={() => handleGroupPageChange(item1.group, (groupPages[item1.group] || 1) + 1)}
                                                                style={buttonStyle}
                                                            >
                                                                Next
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>

                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </Row>
            </CardText>
        </React.Fragment>
    )

}

export default MealMasterContent


const buttonStyle = {
    backgroundColor: 'rgba(0, 86, 179, 0.8)',
    color: '#fff',
    border: 'none',
    padding: '3px 10px', // Adjust padding to make buttons smaller
    margin: '0 1px',
    borderRadius: '4px',
    cursor: 'pointer',
    outline: 'none',
    fontSize: '12px', // Adjust font size to make text smaller
};